<template>
  <div class="copyright content" v-if="res">
    <div class="left">
      <div>
        <span>友情链接：</span>
        <a target="_blank" href="https://m.kuaidi100.com/">快递查询</a>
      </div>
      <p>深圳捷联讯通科技有限公司 © 2019.&nbsp;&nbsp;版权所有</p>
    </div>
    <div class="right">
      <a target="_blank" :href="res.beian1_url">
        <img src="@/assets/img/Copyright/police.png">
        &nbsp;&nbsp;{{res.beian1}}
      </a>
      &nbsp;&nbsp;
      <br class="newline" />
      <a target="_blank" :href="beian2_url">{{beian2}}</a>
      &nbsp;&nbsp;
      <a @click="showCopyright = true">隐私政策</a>
    </div>

    <el-dialog
      :visible.sync="showCopyright"
      :close-on-click-modal="false"
      >
      <h3 style="text-align: center; margin-top: 10px;">隐私政策</h3>
      <div style="min-height: 350px; padding-bottom: 45px;" v-html="res.privacy" />
      <div class="dia-btn-box" style="text-align: center;">
        <el-button type="primary" @click="showCopyright = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {Copyright} from '@/api/index.js'
export default {
  name: 'LayoutCopyright',
  data() {
    return {
      res: null,
      showCopyright: false,
        beian2:'',
        beian2_url:"",

    };
  },
  methods: {
    initData(){
      Copyright().then(res => {
        this.res = res.data;
        // this.beian2=res.data.beian2;
        //   this.beian2_url=res.data.beian2_url;
      });

    }
  },
  components: {

  },
  mounted(){


    this.initData();

      let url= window.location.host;
      let t=url.indexOf("jlxt");
      if(t>=0)
      {
          this.beian2="粤公网安备 44030702003288号";
          this.beian2_url="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030702003288";

      }
      else
      {
          this.beian2="粤公网安备 44030702001530号";
          this.beian2_url="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030702001530";

      }
      // console.log(t);
      // console.log('11111');
      // console.log(window.location.host);
  }
};
</script>

<style lang="css" scoped>
.content{
  width: 88%;
  /* max-width: 1600px; */
  min-height: 90px;
  margin: 0 auto;
  border-top: 2px solid #933;
}

.left{
  float: left;
  width: 30%;
  min-width: 350px;
  height: 90px;
  position: relative;
}

.left>div,.left p{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.left>div{
  top: 36%;
}
.left p{
  top: 64%;
}

.left p{
  vertical-align: text-top;
}

.left *{
  font-size: 15px;
  color: #666;
}

.right{
  float: right;
  width: 70%;
  max-width: calc(100% - 350px);
  height: 90px;
  text-align: right;
  line-height: 90px;
}

.right>a{
  display: inline-block;
  color: #666;
}

.right>a img{
  display: inline;
  height: 26px;
}

.content >>> .el-dialog{
  width: 80%;
  max-width: 1200px;
}

.newline{
  display: none
}

@media screen and (max-width: 920px){
  .content{
    height: auto;
    padding: 15px 0;
  }
  .left{
    float: none;
    width: 100%;
    max-width: initial;
    height: initial;
  }

  .left>div,.left p{
    position: relative;
    text-align: center;
    top: 0;
    transform: translateY(0);
    margin-bottom: 0;
  }

  .right{
    float: none;
    width: 100%;
    max-width: initial;
    height: initial;
    line-height: initial;
    text-align: center;
  }

  .newline{
    display: block;
  }

  .content .left>div,.content .left>p{
    margin: 5px;
  }

  .content .right a{
    margin: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Layout/LayoutCopyright.vue